import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable} from "rxjs";
import { ReferralService } from "../services/referral-service";
import { Referral } from "../models/referral";


@Injectable({ providedIn: 'root' })
export class ReferralResolver implements Resolve<Referral> {
    constructor(private _service: ReferralService) {
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<Referral> | Promise<Referral> | Referral {
        var id = route.paramMap.get('id') != null ? route.paramMap.get('id') : "";
        return this._service.findReferralById(id ? id : "");
    }
}